import { render, staticRenderFns } from "./DataFormInput.vue?vue&type=template&id=aef5f56c&"
import script from "./DataFormInput.vue?vue&type=script&lang=js&"
export * from "./DataFormInput.vue?vue&type=script&lang=js&"
import style0 from "./DataFormInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports